// Tracking for src/components/ActionButtons/ContactIframeButton.jsx

export const TrackingContactIframeButton = {
  type: 'Contact us',
  event: 'click'
};